import { Button } from "@/components/ui/button";
import { Ban, Plus } from "lucide-react";
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
  } from "@/components/ui/alert-dialog"
import { PaymentsService } from "@/services/payments.service";
import { toast } from "sonner";
  interface subcription{
    subscription_id:string
  }
export default function ButtonResume({subscription_id}:subcription) {
    function handlerCancel() {
        PaymentsService.continueSubscription(subscription_id)
        .then((res) => {
            toast.success("Подписка возобновлена")
            setTimeout(() => {
                window.location.reload()
            }, 1000);
        })
        .catch((error) => {
            toast.error(error.response?.data?.message || "Ошибка возобновления подписки")
        })
        
       
        
    }
    return (
        <AlertDialog>
      <AlertDialogTrigger asChild>
      <Button variant="outline" className="w-full text-white gap-2 bg-gradient-to-r from-blue-400 to-purple-500" >
            <Plus className="w-4 h-4" /> Возобновить подписку
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Вы точно хотите возобновить подписку?</AlertDialogTitle>
          <AlertDialogDescription>
            Подписку можно отменить в любое время.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Отмена</AlertDialogCancel>
          <AlertDialogAction onClick={handlerCancel}>Продолжить</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
        
    )
}